import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Product from "./Product";
import Loading from "../components/Loading";

import Data from "../../repository";

import styles from '../../styles/Tokens.module.scss';

function GiftVouchers() {
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const { search } = useLocation();

    useEffect(async () => {
        setProducts(await fetchProducts());
        setLoading(false);
    }, [])

    const fetchProducts = async () => {
        const result = await Data.fetchPublicProducts();
        return result.data;
    }

    if(loading) return <Loading button={false} />

    return (
        <div className={styles.products}>
            {search.includes('paymentStatus') ?
                <div className={styles.container}>
                    {search.includes('success') ? <p className={styles.success}>Your payment was successful!</p> : null}
                    {search.includes('pending') ? <p className={styles.notSuccess}>Your payment is pending, please check back soon.</p> : null}
                    {search.includes('failed') ? <p className={styles.notSuccess}>Your payment did not complete, please try again.</p> : null}
                </div>
            : null}
            {!products.length && <div className={styles.none}><p>There aren't any products available for purchase, please try again later.</p></div>}

            {products.map((product) => {
                return <Product {...product} />
            })}
        </div>
    );
}

export default GiftVouchers;
